import { AVIFDefaultText } from 'global-styles';
import React from 'react';
import styled from 'styled-components';
import { AVIFHeadTextComponent } from './AVIFCommonComponents';
import AVIFSpeedQualityTestImageArea from './AVIFSpeedQualityTestImageArea';

import treeAImg from 'public/asset/product/pulsar/05-AVIF/tree/a.png';
import treeBImg from 'public/asset/product/pulsar/05-AVIF/tree/b.jpg';
import treeCImg from 'public/asset/product/pulsar/05-AVIF/tree/c.png';
import treeDImg from 'public/asset/product/pulsar/05-AVIF/tree/d.png';

import yachtAImg from 'public/asset/product/pulsar/05-AVIF/yacht/a.png';
import yachtBImg from 'public/asset/product/pulsar/05-AVIF/yacht/b.jpg';
import yachtCImg from 'public/asset/product/pulsar/05-AVIF/yacht/c.png';
import yachtDImg from 'public/asset/product/pulsar/05-AVIF/yacht/d.png';

const AVIFDetailExamples = () => {
  return (
    <AVIFDetailExamplesContainer>
      <AVIFHeadTextComponent>Examples</AVIFHeadTextComponent>

      <AVIFDefaultText
        style={{ padding: '0 0 24px 0', display: 'inline-block' }}
      >
        CLIC, 2048x1320, john-price-5258
      </AVIFDefaultText>
      <div className="t-imgs-area">
        <AVIFSpeedQualityTestImageArea
          src={treeAImg.src}
          imgOgCompText="(a) original"
          sizeAndContainerText="png / 3,604kb"
          paddingTopPercentage="64.48%"
        />
        <AVIFSpeedQualityTestImageArea
          src={treeBImg.src}
          imgOgCompText="(b) compressed"
          sizeAndContainerText="jpeg / 132kb"
          paddingTopPercentage="64.48%"
          scoreText="psnr=40.7dB, ssim=0.964, vmaf=89.96"
        />
      </div>

      <div className="t-imgs-area">
        <AVIFSpeedQualityTestImageArea
          src={treeCImg.src}
          imgOgCompText="(c) compressed"
          sizeAndContainerText="aom avif / 66kb"
          paddingTopPercentage="64.48%"
          scoreText="psnr=41.93, ssim=0.973, vmaf=88.82"
        />
        <AVIFSpeedQualityTestImageArea
          src={treeDImg.src}
          imgOgCompText="(d) compressed"
          sizeAndContainerText="pulsar avif / 67kb"
          paddingTopPercentage="64.48%"
          scoreText="psnr=42.01, ssim=0.972, vmaf=88.62"
        />
      </div>

      <AVIFDefaultText style={{ padding: '24px 0', display: 'inline-block' }}>
        Kodak, 512x768, kodim09
      </AVIFDefaultText>
      <div className="y-imgs-area">
        <AVIFSpeedQualityTestImageArea
          src={yachtAImg.src}
          imgOgCompText="(a) original"
          sizeAndContainerText="png / 582.9kb"
          paddingTopPercentage="150%"
        />
        <AVIFSpeedQualityTestImageArea
          src={yachtBImg.src}
          imgOgCompText="(b) compressed"
          sizeAndContainerText="jpeg / 16.2kb"
          paddingTopPercentage="150%"
          scoreText="psnr=34.19, ssim=0.914, vmaf=81.4"
        />
      </div>

      <div className="y-imgs-area">
        <AVIFSpeedQualityTestImageArea
          src={yachtCImg.src}
          imgOgCompText="(c) compressed"
          sizeAndContainerText="aom avif / 6.2kb"
          paddingTopPercentage="150%"
          scoreText="psnr=34.99, ssim=0.923, vmaf=75.7"
        />
        <AVIFSpeedQualityTestImageArea
          src={yachtDImg.src}
          imgOgCompText="(d) compressed"
          sizeAndContainerText="pulsar avif / 7.1kb"
          paddingTopPercentage="150%"
          scoreText="psnr=35.49, ssim=0.927, vmaf=77.6"
        />
      </div>
    </AVIFDetailExamplesContainer>
  );
};

export default AVIFDetailExamples;

const AVIFDetailExamplesContainer = styled.div`
  padding-bottom: 24px;
  .t-imgs-area,
  .y-imgs-area {
    display: flex;
    padding: 0 24px;
  }
  .t-imgs-area + .t-imgs-area,
  .y-imgs-area + .y-imgs-area {
    margin-top: 24px;
  }
  @media screen and (max-width: 904px) {
    .t-imgs-area,
    .y-imgs-area {
      flex-direction: column;
    }

    .t-imgs-area + .t-imgs-area,
    .y-imgs-area + .y-imgs-area {
      margin-top: 0;
    }
  }
`;
